import React from "react";
import LogoAuth from "../../assets/images/LogoAuth.png";
import {
  Box,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";

function AuthLayout({ handleApiKey }) {
  const { t } = useTranslation();

  const smUp = useMediaQuery((theme) => theme.breakpoints.up("sm"), {
    defaultMatches: true,
    noSsr: false,
  });

  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"), {
    defaultMatches: true,
    noSsr: false,
  });

  const formik = useFormik({
    initialValues: {
      apiKey: "",
    },
    validationSchema: Yup.object({
      apiKey: Yup.string().required(t("required_field")),
    }),
    onSubmit: (values) => {
      handleApiKey(values.apiKey);
    },
  });

  return (
    <Grid container>
      {smUp && (
        <Grid item xs={5}>
          <div className="auth-backgound-image">
            <img
              alt="Nothing"
              style={{ paddingLeft: "60px", height: "20vh" }}
              src={LogoAuth}
            ></img>
            <div style={{ marginTop: "20vh", padding: "0px 60px", width: "73%" }}>
              <p
                style={{
                  color: "#FFFFFF",
                  display: "block",
                  fontSize: mdUp ? "64px" : "34px",
                }}
                className="auth-backgound-title"
              >
                <span>{t("get_intouch")}</span>
                <br />
                <span>{t("with_expert")}</span>
              </p>
            </div>
          </div>
        </Grid>
      )}
      <Grid item xs={12} sm={7}>
        <div
          style={{
            height: "calc(100vh - 125px)",
            padding: mdUp ? "20px 100px" : "20px 50px",
            overflow: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Box>
              <h1>{t("confirm_identity")}</h1>
            </Box>
            <br></br>
            <Box component="main">
              <form onSubmit={formik.handleSubmit}>
                <div style={{ height: "120px" }}>
                  <Typography variant="subtitle2">API KEY</Typography>

                  <TextField
                    error={Boolean(
                      formik.touched.apiKey && formik.errors.apiKey
                    )}
                    fullWidth
                    helperText={formik.touched.apiKey && formik.errors.apiKey}
                    margin="normal"
                    name="apiKey"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    type="text"
                    value={formik.values.apiKey}
                    placeholder={t("type_api")}
                  />
                </div>
                <Box sx={{ py: 2 }}>
                  <Button
                    color="secondary"
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    {t("confirm")}
                  </Button>
                </Box>
              </form>
            </Box>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default AuthLayout;
